import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Shield } from "lucide-react";
import { toast } from "sonner";
import EmberField from "@/components/EmberField";

export default function AdminLogin() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [need2fa, setNeed2fa] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password, otp: otp || undefined });
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success(`welcome back, ${r.data.user.email}`);
      nav("/admin/console");
    } catch (err) {
      const detail = formatApiErrorDetail(err.response?.data?.detail) || err.message;
      if (detail.toLowerCase().includes("2fa")) setNeed2fa(true);
      toast.error(detail);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-[70vh]">
      <EmberField count={16} />
      <div className="relative mx-auto max-w-md px-4 sm:px-6 py-16">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#FFC940]">
          <Shield className="w-4 h-4" /> admin console
        </div>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-black">keeper of the <span className="ember-text">campfire</span></h1>

        <form onSubmit={submit} className="mt-6 rounded-xl border border-[#3A2E1C] bg-[#141008] p-6 space-y-4" data-testid="admin-login-form">
          <div>
            <Label>Email</Label>
            <Input data-testid="admin-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0A0906] border-[#3A2E1C]" />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="admin-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#0A0906] border-[#3A2E1C]" />
          </div>
          {need2fa && (
            <div>
              <Label>2FA code</Label>
              <Input data-testid="admin-otp" required={need2fa} value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="6-digit TOTP" className="bg-[#0A0906] border-[#3A2E1C] mono" />
            </div>
          )}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full h-11 bg-[#FFAB00] hover:bg-[#FFC940] text-[#0A0906] font-semibold">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null} enter
          </Button>
        </form>
      </div>
    </div>
  );
}
